module.exports = __webpack_public_path__ + "static/bluebunny-278dab683d12eb8acafb92e1d2ba0e0e.jpeg";